import { AssetsRow, ContactsRow, SmartSharesRow } from '@/lib/features/Dashboard/components/Rows'
import { useDashboard } from '@/lib/features/Dashboard/api'

import { FeatureTypes } from '@/lib/utils/features'

import { Wrapper } from './Dashboard.styles'

export const Dashboard = () => {
  const { data: dashboardData, isLoading, mutate: refreshDashboard } = useDashboard()

  const refreshAssets = async () => {
    return await refreshDashboard()
  }

  const fetchShares = async () => {
    return await refreshDashboard()
  }

  return (
    <Wrapper>
      <AssetsRow onUpdate={refreshAssets} dashboardData={dashboardData} isLoading={isLoading} />
      <SmartSharesRow
        onUpdate={(features) => {
          if (features.includes(FeatureTypes.ASSETS)) {
            refreshAssets()
          }

          if (features.includes(FeatureTypes.SHARES)) {
            fetchShares()
          }
        }}
        dashboardData={dashboardData}
        isLoading={isLoading}
      />
      <ContactsRow dashboardData={dashboardData} isLoading={isLoading} />
    </Wrapper>
  )
}
